import { render } from "./Timer.vue?vue&type=template&id=4bc72e82&scoped=true"
import script from "./Timer.vue?vue&type=script&lang=js"
export * from "./Timer.vue?vue&type=script&lang=js"

import "./Timer.vue?vue&type=style&index=0&id=4bc72e82&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4bc72e82"

export default script